import axios from 'axios';
import { unref } from 'vue';
const httpClient = axios.create({
	baseURL: '/apps3/cheque-order'
});

const init = () => httpClient.get('/health-check');
const sendForm = (data, locale) =>
	httpClient.post('/cash-payment-authorization-form', data, {
		responseType: 'blob',
		headers: {
			'Accept-Language': unref(locale)
		}
	});
const captcha = () => httpClient.get('/captcha');

export const useCashPaymentAuthorizationApi = () => ({
	init,
	sendForm,
	captcha
});
